/* Cross sell quick add. Adds without a page load, tells the drawer to refresh,
   and reports failure in place rather than silently doing nothing.

   21 Sep: the tag is printed by cart-drawer, anyra-reels and anyra-crosssell,
   so a page with the drawer and reels carries it twice and the second copy
   threw "Identifier 'AnyraCrossSell' has already been declared" on every
   page. The class is now block-scoped behind a window guard, so the second
   evaluation is a no-op and the click handler binds exactly once. */
if (!window.AnyraCrossSell) {
  class AnyraCrossSell {
    static init() {
      if (AnyraCrossSell._bound) return;
      AnyraCrossSell._bound = true;
      document.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-anyra-xsell-add]');
        if (!btn) return;
        e.preventDefault();

        const root = btn.closest('.anyra-xsell');
        const msg = root?.querySelector('[data-anyra-xsell-msg]');
        const say = (text, bad) => {
          if (!msg) return;
          msg.textContent = text;
          msg.hidden = !text;
          msg.classList.toggle('anyra-xsell__msg--error', !!bad);
        };

        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding';
        say('');

        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }),
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'That could not be added.');
          }
          btn.textContent = 'Added';
          say(`${btn.dataset.title} added to your cart.`);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1600);
        } catch (err) {
          btn.textContent = original;
          btn.disabled = false;
          say(err.message, true);
        }
      });
    }
  }
  window.AnyraCrossSell = AnyraCrossSell;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => AnyraCrossSell.init());
  } else {
    AnyraCrossSell.init();
  }
}
